export enum GridViewSettingsEnum {
  BOTTOM_GRID_VIEW = "bottom-grid-view",
  FULL_GRID_VIEW = "full-grid-view",
}
